import { Page } from "../page";

export class AsnInfoSearchRequest{

  externMoveOrderKey: String[] | null;
  plant: String | null;
  sku: String | null;
  storer: String | null;
  facility: String | null;

  constructor(){
    this.facility = null;
    this.plant = null;
    this.sku = null;
    this.storer = null;
    this.externMoveOrderKey = null;
  }
}
